export default __webpack_public_path__ + "static/media/question-bank.49ff3154.svg";